import { ReactNode } from "react";
import { Box, IconButton, Paper, Typography, alpha } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";

interface Props {
  /** "Garantía N": solo cuando hay más de una; sin título la card no lleva encabezado ni botón de quitar. */
  title?: string;
  onRemove: () => void;
  removeDisabled: boolean;
  removeTestId: string;
  children: ReactNode;
}

/** Card de una garantía (`S_Garantia`): encabezado "Garantía N" con la papelera para quitarla y su formulario. */
export const PaperGarantia = ({ title, onRemove, removeDisabled, removeTestId, children }: Props) => (
  <Paper
    variant="lendia_paper"
    sx={(theme) => ({
      mb: "16px",
      transition: "border-color .2s ease, box-shadow .2s ease",
      // Mientras se edita, la tarjeta toma el color de la marca con un halo, como en el prototipo.
      "&:focus-within": {
        borderColor: "primary.main",
        boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.16)}`,
      },
    })}
  >
    {title && (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: "primary.dark" }}>
          {title}
        </Typography>
        <IconButton
          size="small"
          aria-label={`Quitar ${title.toLowerCase()}`}
          onClick={onRemove}
          disabled={removeDisabled}
          data-testid={removeTestId}
          sx={{ color: "text.secondary" }}
        >
          <DeleteOutline fontSize="small" />
        </IconButton>
      </Box>
    )}
    {children}
  </Paper>
);
